import React from "react";
import values from "lodash/values";
import { FlatButton, RaisedButton, Checkbox } from "material-ui";
import { Table, Tr, Td, Sort } from "reactable";
import { Link } from "react-router";

import config from "../config";

import OrderTable from "./partials/order-table.jsx";
import TableRefreshIndicator from "./partials/table-refresh-indicator.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import OrderActions from "../actions/OrderActions";
import OrderStore from "../stores/OrderStore";
import UserStore from "../stores/UserStore";
import UserActions from "../actions/UserActions";

class Order extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showZeroOrders: true,
      isGodView: false
    };

    this._makeCsvLink = this._makeCsvLink.bind(this);
    this._onShowZeroOrderCheck = this._onShowZeroOrderCheck.bind(this);
    this._refresh = this._refresh.bind(this);
    this._onFetchMore = this._onFetchMore.bind(this);
    this._onFetchALotMore = this._onFetchALotMore.bind(this);
  }

  static getStores() {
    return [OrderStore, UserStore];
  }

  static getPropsFromStores() {
    let state = OrderStore.getState();
    state.getOrdersForEventBucket = OrderStore.getOrdersForEventBucket;
    state.apiKey = UserStore.getState().apiKey;
    state.activeGodUser = UserStore.getState().activeGodUser;
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      actions: {
        paddingTop: 20,
        marginTop: 20,
        borderTop: "1px solid #ccc"
      },
      config: {
        // borderBottom: '1px solid #ccc',
        paddingBottom: 10,
        marginBottom: 10
      },
      fetchMoreContainer: {
        marginTop: 20,
        textAlign: "center"
      },
      fetchMoreButton: {
        paddingLeft: 16,
        paddingRight: 16,
        fontSize: "14px",
        fontWeight: "500",
        textTransform: "uppercase"
      }
    };
  }

  _onShowZeroOrderCheck(e, checked) {
    this.setState({ showZeroOrders: checked });
  }

  componentDidMount() {
    OrderActions.fetchMore.defer({
      top: true,
      eventBucket: this.props.params.eventBucketId,
      godOrders: this.props.route.name === "god-orders"
    });
    this.setState({
      isGodView: this.props.route.name === "god-orders"
    });
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      isGodView: newProps.route.name === "god-orders"
    });
  }

  _makeCsvLink() {
    var bucket = this.props.params.eventBucketId;

    return `${config.endpoint}orders.csv?${UserStore.makeApiKeyQueryString()}${
      bucket ? `&conditions=${JSON.stringify({ event_bucket: bucket })}` : ""
    }`;
  }

  _refresh() {
    OrderActions.fetchMore({
      top: true,
      eventBucket: this.props.params.eventBucketId,
      godOrders: this.state.isGodView
    });
  }

  _onFetchMore() {
    OrderActions.fetchMore({
      eventBucket: this.props.params.eventBucketId,
      godOrders: this.state.isGodView
    });
  }

  _onFetchALotMore() {
    OrderActions.fetchMore({
      limit: 300,
      eventBucket: this.props.params.eventBucketId,
      godOrders: this.state.isGodView
    });
  }

  render() {
    let orders,
      styles = this.getStyles(),
      eventBucket = this.props.params.eventBucketId;

    if (eventBucket) {
      orders = this.props.getOrdersForEventBucket(eventBucket);
    } else {
      orders = values(this.props.orders);
      if (!this.state.isGodView && this.props.activeGodUser) {
        orders = orders.filter(o => o.owner === this.props.activeGodUser);
      }
    }

    if (!this.state.showZeroOrders) {
      orders = orders.filter(o => o.purchase_price);
    }

    return (
      <div>
        {this.state.isGodView ? <h1>God Orders</h1> : null}
        <div style={styles.config}>
          <Checkbox
            defaultChecked={true}
            label="Show $0.00 orders"
            style={{ float: "left", width: 200 }}
            onCheck={this._onShowZeroOrderCheck}
          />
          <TableRefreshIndicator
            isRefreshing={this.props.isFetchingMore}
            onRefresh={this._refresh}
          />
        </div>
        <OrderTable
          orders={orders}
          eventBucket={eventBucket}
          location={this.props.location}
          noSort={true}
          hideNoOrdersMessage={this.props.isFetchingMore}
          showEventBucket={this.state.isGodView}
          onClick={order => {
            if (this.state.isGodView) {
              UserActions.setGodUser(order.owner);
            }
          }}
        />
        <div style={styles.fetchMoreContainer}>
          <FlatButton
            style={styles.fetchMoreButton}
            onTouchTap={this._onFetchMore}
            disabled={this.props.haveFetchedAll || this.props.isFetchingMore}
          >
            {this.props.isFetchingMore
              ? "Loading..."
              : this.props.haveFetchedAll
              ? "All orders loaded"
              : "Load 50 earlier orders"}
          </FlatButton>
          {!this.props.haveFetchedAll && !this.props.isFetchingMore ? (
            <FlatButton
              style={styles.fetchMoreButton}
              onTouchTap={this._onFetchALotMore}
            >
              Load 300
            </FlatButton>
          ) : null}
        </div>
        <div style={styles.actions}>
          {/*<RaisedButton href={this._makeCsvLink()} target="_blank" label="Export CSV" />*/}
          <p>
            To download a CSV of these or all orders, use{" "}
            <Link to="/reports">Reports</Link>.
          </p>
        </div>
      </div>
    );
  }
}

export default connectToStores(Order);



// WEBPACK FOOTER //
// ./src/app/components/orders.jsx